import { createContext, useContext } from 'react'

// Define the shape of your data and context
interface DescriptionsContextType<T> {
  data: T | null
  loading: boolean
  error: string | null
  fetchData: (url: string, options?: RequestInit) => Promise<void>
}

// Create a context
export const DescriptionsContext = createContext<DescriptionsContextType<any> | undefined>(undefined)

// Hook to use the context
export const useDescriptionsContext = <T>() => {
  const context = useContext(DescriptionsContext)
  if (!context) {
    throw new Error('useDescriptionsContext must be used within an DescriptionsProvider')
  }
  return context as DescriptionsContextType<T>
}
